import { createActions, createReducer } from 'reduxsauce'

import ItemAtaService from '../../servicos/DetalhesAtaRegistroPrecoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaItemAtaInicio: [],
    buscaItemAtaSucesso: ['itemAta'],
    buscaItemAtaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaItemAta = filtro => {
    return dispatch => {
        dispatch(Creators.buscaItemAtaInicio())
        let serv = new ItemAtaService()
        return serv
            .consultarDetalhesItensAta(filtro)
            .then(response => dispatch(Creators.buscaItemAtaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaItemAtaErro(error)))
    }
}

const buscaItemAtaInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaItemAtaErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaItemAtaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.itemAta, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ITEM_ATA_INICIO]: buscaItemAtaInicio,
    [Types.BUSCA_ITEM_ATA_ERRO]: buscaItemAtaErro,
    [Types.BUSCA_ITEM_ATA_SUCESSO]: buscaItemAtaSucesso,
})
